import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiX } from 'react-icons/fi';

interface AlertProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  type: 'success' | 'error';
}

export default function Alert({ isOpen, onClose, message, type }: AlertProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-[510000]">
          <div className="fixed inset-0 bg-[#000]/80" onClick={onClose} />
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative"
          >
            <div className={`p-6 rounded-lg ${type === 'success' ? 'bg-[#008000]/20' : 'bg-[#FF0000]/20'} backdrop-blur-sm`}>
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                  type === 'success' ? 'bg-[#008000]/40' : 'bg-[#FF0000]/40'
                }`}>
                  {type === 'success' ? (
                    <FiCheck size={24} className="text-white" />
                  ) : (
                    <FiX size={24} className="text-white" />
                  )}
                </div>
                <p className="text-white text-lg">{message}</p>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
} 